// extracted by mini-css-extract-plugin
export default {"buttonStyle":"styles_buttonStyle__7nKyu"};